<template>
    <div class="loading-background" :class="{'loading-background--visible': show > 0}">
        <div class="loading-background__inner">
            <img class="loading-background__gif"  :src="'/images/leadance.gif'">
        </div>
    </div>
</template>

<script>

export default {
    props: {
        show: {
            type: Number,
            default: 1
        }
    }
}
</script>

<style scoped lang="scss">
.loading-background{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99999;
    transition: opacity ease-out .2s;
    pointer-events: none;
    opacity: 0;
    background-image: linear-gradient(180deg, transparent 70%, $color-white);

    &--visible {
        opacity: 1;
        pointer-events: all;
    }
}

.loading-background__inner {
    position: absolute;
    left: 0;
    bottom: 0;
    transform: translateX(-100%);
    transition: transform ease-out .2s;

    .loading-background--visible & {
        transform: translateX(0);
    }
}

.loading-background__text{
    color: $color-black;
    font-size: 4rem;
    font-weight: bold;
}
</style>
